import axios from 'axios'
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
const SLIM_USERNAME = process.env.REACT_APP_SLIM_USERNAME
const SLIM_PASSWORD = process.env.REACT_APP_SLIM_PASSWORD
const axiosConfig = {auth: {username:SLIM_USERNAME, password:SLIM_PASSWORD}}


export const serverFetchDataResult = (irl, handleReply) => {
    const url= irl.includes(apiBaseUrl)?irl:apiBaseUrl + irl
    // alert(url)
    // console.log('fetch url:', url);
    axios({	
        method: 'get',
        url,
        axiosConfig
    })
    .then(response => {
       const data = response.data?response.data:response 
       if (data) {
            const status = data.status?data.status:'UNKNOWN STATUS'
            if (status === 'OK') {
                if (Array.isArray(data.result)) {
                    handleReply(data.result);
                } else {
                    const message = '[serverFetchDataResult] data.result is not an array' + 
                    '\n\n\nstatus:' + status + '\ndata ' + JSON.stringify(data) 
                    alert(message)
                }    
            } else { 
                const defaultMessage = '[serverFetchDataResult] Problem occurred when fetching data'
                + '\n\n\nstatus:' + status + '\nmessage:' + JSON.stringify(data) 
                const message = (data.message?data.message:defaultMessage)
                alert(message)
                if (status === 'WARNING') {
                    handleReply(data.result)
                }    
            }    
       } else {
            alert('[serverFetchDataResult] ERROR: No data in reply from url=' + url)  
       }                      
    })
    .catch(e => {
        const message = 'SEVERE ERROR in function serverFetchDataResult '  
        + '\n\n\nurl:' + url + '\nmessage:' + (e.message?e.message:JSON.stringify(e)) 
        alert(message);
    });
}

export const serverFetchData = (irl, handleReply) => {
    const url= irl.includes(apiBaseUrl)?irl:apiBaseUrl + irl
    // alert(url)
    axios({	
        method: 'get',
        url,
        axiosConfig
    })
    .then(response => {
       const data = response.data?response.data:response 
       if (data) {
            const status = data.status?data.status:'UNKNOWN STATUS'
            if (status === 'OK') {
                handleReply(data);
            } else { 
                const defaultMessage = '[serverFetchDataResult] Problem occurred when fetching data'
                + '\n\n\nstatus:' + status 
                + '\nmessage:' + JSON.stringify(data)
                const message = (data.message?data.message:defaultMessage)
                alert(message)
                if (status === 'WARNING') {
                    handleReply(data.result)
                }    
            }    
       } else {
            alert('ERROR (in serverFetchData) No data in reply from url=' + url)
       }                      
    })
    .catch(e => {
        const message = 'SEVERE ERROR in function serverFetchData: No response from url=' + url 
        + "\n\n\nmessage:" + (e.message?e.message:JSON.stringify(e))
        alert(message);
    });
}


export const fetchEmployees = (setFormFields, formFieldsFunc) => {
    serverFetchDataResult('/fetchRows?tableName=tbl_employee',
        result=>{setFormFields(formFieldsFunc(result.sort((a,b)=>a.sequenceNumber?a.sequenceNumber-b.sequenceNumber:a.id-b.id).map(it=>it.name)))})
}

export default serverFetchDataResult